import { isNil } from "lodash-es";
import type { PillVariant } from "../components/pill/Pill";
import type { TranslationKey } from "../state/i18n";
import type { TaskFulfilment, TaskStatus } from "../types/Task";
import { keyFromSelector } from "i18next";

export type FulfilmentStatus = { label: TranslationKey; variant: PillVariant };

export const STATUS_MAP: Record<TaskStatus, FulfilmentStatus> = {
  IN_PROGRESS: { label: keyFromSelector(($) => $.TASKS_STATUS_PENDING), variant: "neutral" },
  COMPLETED: { label: keyFromSelector(($) => $.TASKS_STATUS_COMPLETED), variant: "success" },
  REVOKED: { label: keyFromSelector(($) => $.TASKS_STATUS_REVOKED), variant: "warning" },
  DECLINED: { label: keyFromSelector(($) => $.TASKS_STATUS_DECLINED), variant: "danger" },
};

export const getFulfilmentStatus = (taskFulfilment: TaskFulfilment): FulfilmentStatus | undefined => {
  if (isNil(taskFulfilment)) {
    return undefined;
  }

  if (isNil(taskFulfilment.registrationId)) {
    return { label: keyFromSelector(($) => $.TASKS_STATUS_DECLINED), variant: "danger" };
  }

  return { label: keyFromSelector(($) => $.TASKS_STATUS_COMPLETED), variant: "success" };
};
